import { Pipe, PipeTransform } from '@angular/core';
import { LiveApiService } from '../services/live-api.service';
import { LiveStreamDetails } from '../interfaces/live';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'bbStreamStatusIcon' })

export class BbStreamStatusIcon implements PipeTransform {

	constructor(private liveApiService: LiveApiService, private translate: TranslateService) { }

	transform(item: any): Promise<any> {
		const returnPromise = new Promise((resolve: any, reject: any) => {
			if (item.status && item.sourceid && item.sourceid.startsWith('live_api_')) {
				const uuid = item.sourceid.split('live_api_')[1];
				this.liveApiService.getUrl('/stream/' + uuid).subscribe((livestreamDetails: LiveStreamDetails) => {
					let state;

					if (livestreamDetails.data.ingest && Array.isArray(livestreamDetails.data.ingest)) {
						livestreamDetails.data.ingest.forEach((ingestData) => {
							if (item.status === 'draft' && ingestData.state === 'ingesting') {
								state = 'draft-and-ingesting';
							}

							if (item.status === 'published' && ingestData.state === 'idle') {
								state = 'published-and-idle';
							}
						});
					}

					switch (state) {
						case 'draft-and-ingesting':
							resolve(`<i class="fa fa-cloud-upload black" title="${this.translate.instant('STREAM_DRAFT_AND_INGESTING')}"></i>`);
							break;
						case 'published-and-idle':
							resolve(`<i class="fa fa-exclamation-triangle black" title="${this.translate.instant('STREAM_PUBLISHED_AND_IDLE')}"></i>`);
							break;
						default:
							resolve('');
							break;
					}
				},
				(err: any) => {
					reject('');
				});
			}
		});

		return returnPromise;
	}
}
